import { GetServerSideProps } from 'next';
import { MainLayout, SocialHeadData, ViewProjectUpdateModalController } from '@Components';
import { GroupProfilePageController } from '@Views';
import { fetchServerSideData, getGroupProfilePath } from '@Helpers';
import { ApiErrorObject, GroupProfileData, ProjectUpdate } from '@Types';
import { API } from '@Services';
import { QueryParams } from '@App/paths';

export const getServerSideProps: GetServerSideProps = async ({ params, query }) => {
  let props = {};
  if (params && Number(params.organizationId)) {
    let groupProfileData;
    const organizationId = Number(params.organizationId);
    groupProfileData = await fetchServerSideData<GroupProfileData & ApiErrorObject>(
      API.paths.public_group_profile(organizationId),
    );

    if (groupProfileData.code === 'NOT_FOUND') {
      return { notFound: true };
    }

    props = { ...props, groupProfileData };
  }

  if (query[QueryParams.PROJECT_UPDATE]) {
    const projectUpdateId = Number(query[QueryParams.PROJECT_UPDATE]);
    const projectUpdateData = await fetchServerSideData<ProjectUpdate & ApiErrorObject>(
      API.paths.project_update(projectUpdateId),
    );

    if (projectUpdateData.code === 'NOT_FOUND') {
      return { notFound: true };
    }

    props = { ...props, projectUpdateData };
  }

  return { props };
};

interface GroupProfilePageProps {
  groupProfileData?: GroupProfileData;
  projectUpdateData?: ProjectUpdate;
}

const GroupProfilePage = ({ groupProfileData, projectUpdateData }: GroupProfilePageProps) => {
  return (
    <MainLayout>
      <SocialHeadData
        title={groupProfileData?.name}
        image={groupProfileData?.avatar_image}
        url={
          groupProfileData?.organization_id
            ? `https://www.actionfunder.org${getGroupProfilePath(groupProfileData.organization_id)}`
            : ''
        }
        description={groupProfileData?.description}
      />
      {groupProfileData && (
        <GroupProfilePageController initialGroupProfileData={groupProfileData} />
      )}
      {projectUpdateData && (
        <ViewProjectUpdateModalController initialProjectUpdateData={projectUpdateData} />
      )}
    </MainLayout>
  );
};

export default GroupProfilePage;
